import React from "react";
import AbstractTextInput from "./AbstractTextInput";
import {ValidatorForm} from "react-material-ui-form-validator";
import Rules from "../../../../../config/rules";


class NumSSInput extends AbstractTextInput {

    componentDidMount() {
        ValidatorForm.addValidationRule('isValidSSNum', Rules.isValidSSNum)
    }

    componentWillUnmount() {
        ValidatorForm.removeValidationRule('isValidSSNum');
    }

    label = "Numéro de sécurité sociale*";

    validators = !this.props.isOptional ? ['required', 'isValidSSNum'] : ['isValidSSNum'];

    errorMessages = !this.props.isOptional ? [Rules.txtRequis, Rules.txtInvalidSSNumber]: [Rules.txtInvalidSSNumber]

    specs = {
        helperText: "13 chiffres",
        inputProps: {
            maxLength:18
        },
    };

    onChange = (event) => {
        this.onChangeFormater(event, 'getFormatedNumSS');
    }
}

export default NumSSInput